import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../components/Toast';

export default function NewProject() {
  const { api } = useAuth();
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [creating, setCreating] = useState(false);

  const handleCreate = async () => {
    if (!name.trim()) return;
    setCreating(true);
    try {
      const { data } = await api.post('/v3/project/create', { name: name.trim() });
      navigate(`/v3/project/${data.projectId}`);
    } catch (err) {
      addToast(err.response?.data?.error || '프로젝트 생성 실패', 'error');
      setCreating(false);
    }
  };

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: '#E6EDF3', margin: '0 0 8px' }}>새 프로젝트</h1>
      <p style={{ color: '#8B949E', fontSize: 14, margin: '0 0 32px' }}>프로젝트명을 입력하고 영상 자동편집을 시작하세요</p>

      <div style={styles.card}>
        <label style={styles.label}>프로젝트명</label>
        <input
          style={styles.input}
          placeholder="예: 성장판 시리즈 2026-03"
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleCreate()}
          autoFocus
        />
        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button style={styles.cancelBtn} onClick={() => navigate('/v3/project')}>취소</button>
          <button style={styles.createBtn} onClick={handleCreate} disabled={creating || !name.trim()}>
            {creating ? '생성 중...' : '프로젝트 생성'}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: '#1E2732',
    border: '1px solid #2A3441',
    borderRadius: 16,
    padding: 32,
    maxWidth: 480,
  },
  label: {
    display: 'block',
    color: '#8B949E',
    fontSize: 12,
    fontWeight: 600,
    marginBottom: 8,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    backgroundColor: '#111827',
    border: '1px solid #374151',
    borderRadius: 10,
    color: '#E6EDF3',
    fontSize: 15,
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: "'Noto Sans KR', sans-serif",
  },
  cancelBtn: {
    padding: '10px 20px',
    backgroundColor: '#2A3441',
    border: 'none',
    borderRadius: 10,
    color: '#8B949E',
    fontSize: 14,
    cursor: 'pointer',
    fontFamily: "'Noto Sans KR', sans-serif",
  },
  createBtn: {
    padding: '10px 28px',
    backgroundColor: '#4CAF50',
    border: 'none',
    borderRadius: 10,
    color: '#fff',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: "'Noto Sans KR', sans-serif",
  },
};
